import apiClient from "../utils/apiUtils";

// Fetch all roles
export const fetchRoles = async (token) => {
  try {
    const response = await apiClient.get(`/roles`);
    console.log(response.data);
    return response.data; // Ensure the roles object is returned
  } catch (error) {
    throw error.response?.data || "Error fetching roles.";
  }
};

// Create a new role
export const createRole = async (token, data) => {
  try {
    const response = await apiClient.post(`/roles`, data);
    return response.data.data || response.data.role || response.data;
  } catch (error) {
    const errData = error.response?.data;
    throw {
      message: errData?.message || "Failed to add role.",
      fieldErrors: errData?.errors || {}, // pass full field errors
    };
  }
};

// Get details of a specific role
export const getRoleDetails = async (token, roleId) => {
  try {
    const response = await apiClient.get(`/role/${roleId}`);
    return response.data.role;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update a specific role
export const updateRole = async (token, roleId, data) => {
  try {
    const response = await apiClient.put(`/roles/${roleId}`, data);
    return response.data.role;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete a specific role
export const deleteRole = async (token, roleId) => {
  try {
    const response = await apiClient.delete(`/roles/${roleId}`);
    return response.data.message;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};
